import script from "./QuizDrawerTermsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizDrawerTermsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuizDrawerTermsPanel.vue?vue&type=style&index=0&id=3425d236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3425d236"]])

export default __exports__